import { useMemo, useState } from 'react';
import { ListItemButton } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { ChevronRightTwoTone } from '@mui/icons-material';
import HubList from '@/HubList/HubList';
import { getEnumValueByKey } from '@/Infrastructure/Utilities';
import { LegStatus } from '@api/Trinium/types';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { InsertHubProps } from '@components/DataGrid/Dispatch/types';

import styles from '@components/DataGrid/Dispatch/DataGrid.Dispatch.module.css';

/**
 * Insert Hub Action
 */
export default function InsertHub({ onClose }: InsertHubProps) {
	const gridApiRef = useGridApiContext();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);
	const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

	const legIds = useMemo(() => {
		return Array.from(selectedRowIds.keys()) as number[];
	}, [selectedRowIds]);

	const legs = useMemo(() => {
		return legIds.map((id) => gridApiRef.current.getRow<DispatchLeg>(id));
	}, [gridApiRef, legIds]);

	const isDisabled = useMemo(() => {
		// Disable if any selected Legs do not have accepted LegStatus (PU, AV, NA, or AC)
		return !legs.every((leg) => {
			return [LegStatus.PU, LegStatus.AV, LegStatus.NA, LegStatus.AC].includes(getEnumValueByKey(LegStatus, leg?.legStatus) as LegStatus);
		});
	}, [legs]);

	// This action requires 1 or more rows/Legs to be selected
	if (selectedRowIds.size == 0 || !legs.length) {
		return <></>;
	}

	const handlePopoverClose = () => {
		onClose();
	};

	return (
		<ListItemButton
			onClick={(event) => {
				if (anchorEl == null) setAnchorEl(event.currentTarget);
				else setAnchorEl(null);
				event.stopPropagation();
			}}
			disabled={isDisabled}
		>
			Insert Hub
			<ChevronRightTwoTone
				fontSize='small'
				className={styles['right-justified']}
			/>
			<HubList
				anchor={anchorEl}
				legIds={legIds}
				onClose={handlePopoverClose}
			/>
		</ListItemButton>
	);
}
